// chakra imports
import { Icon, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { MdNotificationsActive } from "react-icons/md";
import React from "react";

export function ItemContent(props) {
  const textColor = useColorModeValue("navy.700", "white");
  return (
    <>
      <Flex
        justify='center'
        align='center'
        borderRadius='16px'
        minH={{ base: "48px", md: "52px" }}
        h={{ base: "48px", md: "52px" }}
        minW={{ base: "48px", md: "52px" }}
        w={{ base: "48px", md: "52px" }}
        me='14px'
        bgGradient='linear(135deg, brand.400, brand.600)'>
        <Icon as={MdNotificationsActive} color='white' w='22px' h='22px' />
      </Flex>
      <Flex flexDirection='column' justify='center'>
        <Text
          fontWeight='700'
          color={textColor}
          fontSize={{ base: "sm", md: "md" }}>
          {props.info}
        </Text>
      </Flex>
    </>
  );
}
